import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useT } from "@/lib/i18n";

// EXPERIMENTAL: compact honor board (top supervisors by combined engagement)
export const HonorBoard = () => {
  const { t } = useT();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/supervisors/leaderboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !(data.top || []).length) return null;
  const tiers = [
    { medal: "🥇", label: t("honor_tier_gold"), ring: "bg-amber-100/80 border-amber-400", badge: "bg-amber-400 text-amber-950" },
    { medal: "🥈", label: t("honor_tier_silver"), ring: "bg-slate-100 border-slate-300", badge: "bg-slate-300 text-slate-800" },
    { medal: "🥉", label: t("honor_tier_bronze"), ring: "bg-orange-50 border-orange-300", badge: "bg-orange-300 text-orange-950" },
  ];

  return (
    <div className="bg-white/80 backdrop-blur border border-amber-200 rounded-2xl p-4 shadow-sm" data-testid="honor-board-widget">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-lg">🏆</span>
        <h3 className="font-black text-amber-800 text-sm">{t("honor_board_title")}</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {data.top.map((s, i) => (
          <div key={s.user_id} className={`relative flex items-center gap-3 rounded-xl px-3 py-3 border ${tiers[i].ring}`} data-testid={`honor-widget-rank-${i + 1}`}>
            <span className={`absolute -top-2 start-2 text-[10px] font-black rounded-full px-2 py-0.5 shadow-sm ${tiers[i].badge}`}>
              {i + 1} · {tiers[i].label}
            </span>
            <span className="text-3xl">{tiers[i].medal}</span>
            <div className="min-w-0">
              <div className="text-xs font-black text-slate-800 truncate">{s.name}</div>
              <div className="text-[13px] font-black text-amber-700">{t("honor_score", { n: s.score })}</div>
              <div className="text-[10px] font-bold text-slate-500">{t("honor_breakdown", { login: s.month_pct, interact: s.interaction_pct })}</div>
            </div>
          </div>
        ))}
      </div>
      {(data.rest || []).length > 0 && (
        <div className="mt-2 space-y-1" data-testid="honor-rest-list">
          {data.rest.map((s, i) => (
            <div key={s.user_id} className="flex items-center justify-between bg-slate-50 border border-slate-100 rounded-lg px-3 py-1.5" data-testid={`honor-rest-${i + 4}`}>
              <span className="text-xs font-bold text-slate-600">
                <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-slate-200 text-slate-600 text-[10px] font-black me-2">{i + 4}</span>
                {s.name}
              </span>
              <span className="text-[11px] font-black text-slate-500">{t("honor_score", { n: s.score })}</span>
            </div>
          ))}
        </div>
      )}
      {data.me && (
        <div className="mt-3 flex items-center justify-between bg-teal-50 border border-teal-200 rounded-xl px-3 py-2" data-testid="honor-my-rank">
          <span className="text-xs font-black text-teal-800">
            {t("honor_my_rank", { rank: data.me.rank, total: data.me.total })}
          </span>
          <span className="text-xs font-black text-teal-700">{t("honor_score", { n: data.me.score })}</span>
        </div>
      )}
    </div>
  );
};
